import { render, staticRenderFns } from "./guHome.vue?vue&type=template&id=2fa81570&scoped=true&"
import script from "./guHome.vue?vue&type=script&lang=js&"
export * from "./guHome.vue?vue&type=script&lang=js&"
import style0 from "./guHome.vue?vue&type=style&index=0&lang=css&"
import style1 from "./guHome.vue?vue&type=style&index=1&id=2fa81570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa81570",
  null
  
)

export default component.exports